import api from '../../api/api';
export async function browseList(kind, values, signal) {
  const {
    category,
    type,
    sort,
    period,
    region,
    page = 1,
    size,
    recommendationSession,
    nativeAdAfter,
    advertisedIds,
  } = values;
  const params = {
    type,
    sort,
    page,
    size,
    region: region === 'korean' ? 'kr' : region,
    period: kind === 'albums' && category === 'recommended' ? null : period,
    recommendationSession,
    nativeAdAfter,
    advertisedIds,
  };
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '' && value !== 'all')
      query.set(key, Array.isArray(value) ? value.join(',') : value);
  });
  const path =
    kind === 'reviews'
      ? '/albums/recent-reviews'
      : category === 'recommended'
        ? '/albums/recommend'
        : '/albums/new-releases';
  const config = { signal, timeout: 15000, suppressGlobalError: true };
  let response;
  try {
    response = await api.getPublic(`${path}?${query}`, config);
  } catch (error) {
    const expired =
      error.response?.status === 400 &&
      error.response?.data?.error?.code === 'INVALID_PARAM' &&
      error.response?.data?.error?.message === '추천 목록이 만료되었습니다. 새로고침해 주세요.';
    if (
      !expired ||
      signal?.aborted ||
      kind !== 'albums' ||
      category !== 'releases' ||
      sort !== 'recommended' ||
      page <= 1 ||
      !recommendationSession
    )
      throw error;
    // A fresh later-page URL has no server-side recommendation order yet.
    // Page one establishes it; retry the requested page once with identical inputs.
    const first = new URLSearchParams(query);
    first.set('page', '1');
    await api.getPublic(`${path}?${first}`, config);
    if (signal?.aborted) throw new DOMException('Aborted', 'AbortError');
    response = await api.getPublic(`${path}?${query}`, config);
  }
  return {
    albums: response.data.data || [],
    pagination: response.data.meta?.pagination || {
      currentPage: page,
      totalPages: 1,
      totalItems: response.data.data?.length || 0,
    },
  };
}
